import  gql  from 'graphql-tag'

export const activityTypes = gql`query activityTypes($isActive: Boolean){ 
    activityTypes(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
